module.exports = __webpack_public_path__ + "static/media/1 38 verdt.cb8fe5c2.mp3";